// extracted by mini-css-extract-plugin
module.exports = {"Container":"ChatPagesContainer_Container__xoCjB","Client":"ChatPagesContainer_Client__ugfsw","MainArea":"ChatPagesContainer_MainArea__JNYgq"};